<template lang="pug">
  el-col.card-holder(:md="8" :lg="6" :xl="4")
    div(@click="onClick")
      el-card.card-inner.card-project(v-if="!isNewProject" shadow="always")
        .card-toolbar
          .card-title {{title}}
          el-dropdown.outline(trigger='click' @command="handleCommand" @visible-change="visibleChange")
            span.el-dropdown-link
              .menu-button
                i.material-icons.more-icon(v-bind:class="{ rotate: isDropdownOpen }") expand_more
            el-dropdown-menu(slot='dropdown')
              el-dropdown-item.flex(command="onEdit")
                i.material-icons edit
                span Editar painel
              el-dropdown-item.flex(v-if="isMyProject" command="onDelete")
                i.material-icons delete
                span Excluir painel
        .card-body {{description}}
      el-card.card-inner.card-new-project(v-else shadow="always")
          span.card-content
            i.material-icons.card-add add
            span Criar novo painel
</template>

<script>

export default {
  props: {
    isMyProject: {
      required: false,
      type: Boolean,
      default: false
    },
    isNewProject: {
      required: false,
      type: Boolean,
      default: false
    },
    id: {
      required: false,
      type: Number
    },
    title: {
      required: false,
      type: String,
      default: ''
    },
    body: {
      required: false,
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isDropdownOpen: false
    }
  },
  computed: {
    description: function () {
      if (!this.body) return ''

      return this.body.length > 75 ? `${this.body.substr(0, 74)} ...` : this.body
    }
  },
  methods: {
    handleCommand (command) {
      this.$emit(command, this.$event, this.id)
    },
    onClick (e) {
      const element = e.srcElement.className
      if (element && !element.includes('material-icons')) {
        this.$emit('onClick', this.$event, this.id)
      }
    },
    visibleChange (data) {
      this.isDropdownOpen = data
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.more-icon {
  color: $color-primary;
  transition: transform 0.25s linear;
}

.menu-button {
  height: 27px;
  width: 27px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: $white;
  border-radius: 5px;
}

.outline:focus {
  outline: none !important;
}

.card-holder {
  margin-top: 20px;
}

.card-inner {
  border: none;
  border-radius: 10px;
  height: 150px;
  cursor: pointer;
}

.card-new-project {
  background-color: #f3f7fa;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-new-project:hover {
  box-shadow: 0 2.6px 5.6px rgba(0, 0, 0, 0.029),
    0 5.3px 13px rgba(0, 0, 0, 0.045), 0 9.4px 26.7px rgba(0, 0, 0, 0.061);
}

.card-project {
  background-color: $color-primary;
}

.card-project:hover {
  box-shadow: 0 2.6px 5.6px rgba(0, 0, 0, 0.029),
    0 5.3px 13px rgba(0, 0, 0, 0.045), 0 9.4px 26.7px rgba(0, 0, 0, 0.061),
    0 20px 80px rgba(0, 0, 0, 0.08);
}

.card-content {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.card-add {
  font-size: 2rem;
  margin-right: 15px;
  padding: 5px;
}

.card-toolbar {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  color: $white;
}

.card-title {
  font-size: 1.25rem;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-body {
  padding: 0px;
  padding-top: 10px;
  color: #eeeeee;
  font-weight: 300;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: left;
}

.material-icons {
  width: 24px;
}

.rotate {
  transform: rotate(180deg);
  transform-origin: center center;
}
</style>



// WEBPACK FOOTER //
// src/screens/demandas/components/Card.vue